module.exports = __webpack_public_path__ + "static/media/loginimage.ec0ac4eb.png";